module.exports = __webpack_public_path__ + "static/img/7areaB_03.a47ace4.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/7areaB_03.png
// module id = 1224
// module chunks = 1